import { render, staticRenderFns } from "./PrintNotesDisplay.vue?vue&type=template&id=a785f6c8&"
import script from "./PrintNotesDisplay.vue?vue&type=script&lang=ts&"
export * from "./PrintNotesDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a785f6c8')) {
      api.createRecord('a785f6c8', component.options)
    } else {
      api.reload('a785f6c8', component.options)
    }
    module.hot.accept("./PrintNotesDisplay.vue?vue&type=template&id=a785f6c8&", function () {
      api.rerender('a785f6c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/PrintNotesDisplay.vue"
export default component.exports